import GridViewIcon from "@mui/icons-material/GridView";
import { SvgIconProps } from "@mui/material";

export const DimensionIcon = (props: SvgIconProps) => {
  return (
    <GridViewIcon
      {...props}
      sx={{ transform: "rotate(45deg)", fontSize: 17, ...props.sx }}
    />
  );
};
